jQuery(function($) {

    function init(map_config) {
        var queryString =
            window.location.search;
        var urlParams =
            new URLSearchParams(queryString);

        var overLayHover = $('#map-tip');
        if (overLayHover.length > 0) {

        } else {
            $('body').prepend('<span id="map-tip" />');
        }

        function isTouchEnabled() {
            return (('ontouchstart' in window)
                || (navigator.MaxTouchPoints > 0)
                || (navigator.msMaxTouchPoints > 0));
        }


        function addEvent(id, relationId) {


            var _obj = $('#' + id);
            var _Textobj = $('#' + id + ',' + '#' + map_config[id]['namesId']);
            var _current = urlParams.get('listing_region');
            if(_current && parseInt(_current) === parseInt(map_config[id]['id'])) {
                _obj.attr(
                    {
                        'fill': map_config[id]['downColor'],
                        'stroke': map_config['default']['borderColor']
                    });
            } else {
                _obj.attr(
                    {
                        'fill': map_config[id]['upColor'],
                        'stroke': map_config['default']['borderColor']
                    });
            }
            _Textobj.attr({'cursor': 'default'});
            if (map_config[id]['enable'] === true) {
                if (isTouchEnabled()) {
                    //clicking effect
                    _Textobj.on('touchstart', function (e) {
                        var touch = e.originalEvent.touches[0];
                        var x = touch.pageX + 10, y = touch.pageY + 15;
                        var tipw = $('#map-tip').outerWidth(),
                            tiph = $('#map-tip').outerHeight(),
                            x = (x + tipw > $(document).scrollLeft() + $(window).width()) ? x - tipw - (20 * 2) : x
                        y = (y + tiph > $(document).scrollTop() + $(window).height()) ? $(document).scrollTop() + $(window).height() - tiph - 10 : y
                        $('#' + id).css({'fill': map_config[id]['downColor']});
                        $('#map-tip').show().html(map_config[id]['hover']);
                        $('#map-tip').css({left: x, top: y})

                        $('#map-tip').remove();
                    })
                    _Textobj.on('touchend', function () {
                        $('#' + id).css({'fill': map_config[id]['upColor']});
                        if (map_config[id]['target'] === 'new_window') {
                            window.open(map_config[id]['url']);
                        } else if (map_config[id]['target'] === 'same_window') {
                            window.location.href = map_config[id]['url'];
                        }


                    })
                }
                _Textobj.attr({'cursor': 'pointer'});
                _Textobj.hover(function () {
                    //moving in/out effect
                    $('#map-tip').show().html(map_config[id]['hover']);
                    _obj.css({'fill': map_config[id]['overColor']})
                }, function () {
                    $('#map-tip').hide();
                    $('#' + id).css({'fill': map_config[id]['upColor']});
                });
                //clicking effect
                _Textobj.on('click', function () {
                    $('#' + id).css({'fill': map_config[id]['downColor']});

                    window.location.replace(map_config[id]['url']);

                });
                _Textobj.mouseup(function () {
                    $('#' + id).css({'fill': map_config[id]['overColor']});
                    if (map_config[id]['target'] === 'new_window') {
                        window.open(map_config[id]['url']);
                    } else if (map_config[id]['target'] === 'same_window') {
                        window.location.href = map_config[id]['url'];
                    }
                });
                _Textobj.mousemove(function (e) {
                    var x = e.pageX + 10, y = e.pageY + 15;
                    var tipw = $('#map-tip').outerWidth(),
                        tiph = $('#map-tip').outerHeight(),
                        x = (x + tipw > $(document).scrollLeft() + $(window).width()) ? x - tipw - (20 * 2) : x
                    y = (y + tiph > $(document).scrollTop() + $(window).height()) ? $(document).scrollTop() + $(window).height() - tiph - 10 : y
                    $('#map-tip').css({left: x, top: y})
                });
                //}
            }
        }

        $('#map-tip').css({
            'box-shadow': '1px 2px 4px ' + map_config['default']['hoverShadow'],
            '-moz-box-shadow': '2px 3px 6px ' + map_config['default']['hoverShadow'],
            '-webkit-box-shadow': '2px 3px 6px ' + map_config['default']['hoverShadow'],
        });

        if ($('#shadow').find('path').eq(0).attr('fill') !== 'undefined') {
            var shadowOpacity = map_config['default']['shadowOpacity'];
            var shadowOpacity = parseInt(shadowOpacity);
            if (shadowOpacity >= 100) {
                shadowOpacity = 1;
            } else if (shadowOpacity <= 0) {
                shadowOpacity = 0;
            } else {
                shadowOpacity = shadowOpacity / 100;
            }

            $('#shadow').find('path').attr({'fill': map_config['default']['mapShadow']}).css({'fill-opacity': shadowOpacity})
        }


        addEvent('map_1');
        addEvent('map_2');
        addEvent('map_3');
        addEvent('map_4');
        addEvent('map_5');
        addEvent('map_6');
        addEvent('map_7');
        addEvent('map_8');
        addEvent('map_9');
        addEvent('map_10');
        addEvent('map_11');
        addEvent('map_12');
        addEvent('map_13');
        addEvent('map_14');
        addEvent('map_15');
        addEvent('map_16');
        addEvent('map_17');
        addEvent('map_18');


        $('#mapwrapper').removeClass('hide').addClass('show');
    }

    $.ajax({
        type : "post",
        url : Globals.ajax_url,
        data : { action: Directory.namespace + 'get_regions_data' },
        success: function(response) {
            let data = JSON.parse(response);
            if(data.map_1!==undefined) {
                console.log(response);
                init(JSON.parse(response));
            }
        },
        error: function(xhr, status, error){
            console.log({xhr, status, error});
        }
    });
});